import { render } from "./LockPolicyHint.vue?vue&type=template&id=f6f22f44"
import script from "./LockPolicyHint.vue?vue&type=script&lang=js"
export * from "./LockPolicyHint.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__